<fcom-flight-card
  *ngIf="disruptedOrOriginalBound"
  [disabled]="isFlown"
  [type]="(isComplexJourney ? 'MMB.view.tripCard.outbound' : type ? 'MMB.view.tripCard.' + type : '') | finLocalization"
  [date]="disruptedOrOriginalBound.departure.dateTime | finDateFormat: 'FULL_NO_YEAR'"
  [cabin]="bound.cabinClass | titlecase"
  [showDivider]="checkInOpen"
  [disruptedLabel]="disruptedLabel"
>
  <fin-mmb-notifications
    *ngIf="notifications$ | async as notifications"
    [notifications]="notifications"
  ></fin-mmb-notifications>

  <fcom-ufo
    [arrival]="getLocation(disruptedOrOriginalBound.arrival) | async"
    [departure]="getLocation(disruptedOrOriginalBound.departure) | async"
    [tails]="tails | finTailNames"
    [isByBusOnly]="isByBusOnly"
    [airlines]="disruptedOrOriginalBound.uniqueAirlineNames"
    [duration]="disruptedOrOriginalBound.duration | finDuration | async"
    [stops]="disruptedOrOriginalBound.stops"
    [focusOnViewDetails$]="viewDetailsClosed$"
    (viewDetails)="openViewDetails()"
    [showViewDetails]="showViewDetails"
    [flightNumbers]="disruptedOrOriginalBound.itinerary | finFlightNumbers"
  ></fcom-ufo>

  <fcom-button
    *ngIf="checkInOpen && !enableNewCheckin"
    data-testid="go-to-check-in-button"
    class="float-right"
    [focus$]="checkInModalClosed$"
    [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
    [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
    [mode]="ButtonMode.FILL_MOBILE"
    [attr.aria-label]="'ariaLabels.newTab' | finLocalization"
    [text]="'MMB.notifications.checkInOpen.linkText' | finLocalization"
    (clickBtn)="redirectToCheckIn(bound)"
  ></fcom-button>
</fcom-flight-card>

<fin-check-in-trigger *ngIf="enableNewCheckin" [order]="order" [bound]="bound"></fin-check-in-trigger>

<fcom-modal
  *ngIf="checkInModalArticle$ | async as article"
  data-testid="check-in-modal"
  [open]="checkInModalOpen"
  (close)="checkInModalClosed$.next(true)"
  (openChange)="checkInModalOpen = $event"
  [fitToContent]="true"
  [title]="article.teaserTitle"
  [buttons]="ModalButtons.CUSTOM"
>
  <cms-unstyled-fragment [showTitle]="false" [cmsContent$]="checkInModalArticle$" class="block pr-medium" />

  <div buttons>
    <fcom-button
      (clickBtn)="redirectToCheckIn(disruptedOrOriginalBound, true)"
      data-testid="checkin-redirect-button"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [text]="'MMB.checkIn.upsellModal.redirect' | finLocalization"
      [aria]="{ label: 'MMB.checkIn.upsellModal.redirect' | finLocalization, role: 'button' }"
      class="mr-xsmall-r"
    ></fcom-button>
    <fcom-button
      (clickBtn)="emitUpsell(Category.SEAT)"
      data-testid="checkin-upsell-button"
      [text]="'MMB.checkIn.upsellModal.upsell' | finLocalization"
      [aria]="{ label: 'MMB.checkIn.upsellModal.upsell' | finLocalization, role: 'button' }"
    ></fcom-button>
  </div>
</fcom-modal>

<fcom-modal
  [open]="itineraryModalOpen"
  (close)="viewDetailsClosed$.next(true)"
  (openChange)="itineraryModalOpen = $event"
  [title]="'MMB.view.itineraryModal.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
>
  <fin-itinerary-timeline
    [bound]="disruptedOrOriginalBound"
    [locations]="locations"
    [boundType]="type"
    class="block pr-medium"
  >
  </fin-itinerary-timeline>
</fcom-modal>
